export const STATISTICS = '/statistics';
export const LOGIN = '/log_in';
export const REGISTER = '/register';
export const SDK = '/sdk';
export const DASHBOARD = '/dashboard';
